<template>
  <div>
    <div class="item">
      <div class="item-detail">
        <b>
          {{ name || "ชื่อผู้ใช้งาน" }}
        </b>
        <p class="subtitle">
          {{ display(input.mobileNo) || 'เบอร์มือถือ' }}
        </p>
      </div>
      <div class="item-action">
        <el-button type="sc-asset" @click="() => (modal.open = true)">
          {{ valid ? "เปลี่ยน" : "เลือก" }}
        </el-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="modal.open"
      :close-on-click-modal="false"
      class="user-dialog"
    >
      <div slot="title" class="dialog-title">
        <b> เลือกผู้ใช้งาน </b>
      </div>

      <div class="page-content">
        <section>
          <div class="action-panel">
            <div panel="main">
              <input
                v-model="filter.text"
                :placeholder="'ค้นหาชื่อนามสกุล, เบอร์มือถือ, หรือ อีเมล์'"
                type="text"
                class="el-input__inner"
                @keyup.enter="() => search(filter.text)"
              />
            </div>
            <div panel="action">
              <el-button
                icon="
                  el-icon-search
                "
                @click="() => search(filter.text)"
              >
                ค้นหา
              </el-button>
            </div>
          </div>
        </section>

        <section v-if="loader" class="empty">
          <p>
            <b class="unknown"> กำลังค้นหา </b>
          </p>
        </section>

        <section v-if="!loader && items.length > 0" class="content">
          <div v-for="(item, i) in items" :key="i" class="item">
            <div class="user-detail">
              <b> {{ item.firstName }} {{ item.lastName }} </b>
              <p class="subtitle">
                {{ display(item.mobileNo) }}
              </p>
            </div>
            <el-button plain type="sc-asset" @click="() => select(item)">
              เลือก
            </el-button>
          </div>
        </section>

        <section v-else-if="!loader" class="empty">
          <img src="@/assets/images/admin/empty.png" />
          <p>
            <b class="unknown"> ไม่พบข้อมูล </b>
          </p>
        </section>

        <section v-if="!loader && items.length > 0" class="footer">
          <el-pagination
            :background="true"
            :layout="'prev, pager, next'"
            :pager-count="5"
            :current-page="paging.page"
            :page-size="paging.limit"
            :total="paging.total"
            @current-change="(page) => search(filter.text, page)"
          />
          <label> พบ {{ paging.total }} รายการ </label>
        </section>
      </div>
    </el-dialog>

    <!-- Loader -->
    <div
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)"
    ></div>
  </div>
</template>

<script lang="js">
// Feature
import { NonScFeature } from "../feature"

// Utils
import { ValidateUtility as Validate } from "../utils/validate"

import {
  display, isValidNewInput
} from '../utils/phone'

export default {
  props: {
    selected: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loader: false,
      input: {
        firstName: "",
        lastName: "",
        mobileNo: "",
        email: "",
      },
      modal: {
        open: false,
      },
      filter: {
        text: "",
      },
      paging: {
        page: 1,
        limit: 10,
        total: 0,
      },
      items: [],
      value: null,
    }
  },
  computed: {
    clientUser() {
      return NonScFeature.user
    },
    name() {
      // Validate User
      if (!this.input) return null

      // Input Props
      const { firstName, lastName } = this.input

      // Name Validator
      const isName = !!firstName && !!lastName

      // Validate Name
      if (isName) {
        return [firstName, lastName].join(" ")
      }

      return null
    },
    valid() {
      // Validator
      const valid = {
        email: false,
        firstName: false,
        lastName: false,
        mobileNo: false,
        role: false,
      }

      // Validate Input
      if (!this.input) return valid

      // Input Props
      const { firstName, lastName, mobileNo, email } = this.input

      // Validate Name
      valid.firstName = !!firstName
      valid.lastName = !!lastName

      // Validate Mobile Number
      valid.mobileNo = (
        !!mobileNo && isValidNewInput(mobileNo)
      )

      // Validate Email
      valid.email = email ? Validate.isEmail(email) : true

      return Object.values(valid).every((e) => !!e)
    },
  },
  watch: {
    selected: {
      handler(value) {
        this.setInput(value)
      },
      deep: true,
    },
    "modal.open": function modalOpenWatcher(open) {
      if (open) {
        this.search(this.filter.text, this.paging.page)
      }
    },
  },
  mounted() {
    // Init Modal
    this.modal.open = false

    // Init Input
    this.setInput(this.selected)
  },
  methods: {
    setInput(value = {}) {
      // Validate Value
      if (!value) return

      // Input Key
      const keys = Object.keys(this.input)

      // Set Input
      keys.forEach((key) => {
        this.input[key] = value[key]
      })
    },
    display,
    async search(text, page = 1) {
      // Loading
      this.loader = true

      try {
        // Filter Limitation
        const { limit } = this.paging

        // Fetch Params
        const params = {
          text,
          page,
          limit,
        }

        // Fetch Location List
        const { items, total } = await this.clientUser.list(params)

        // Set Items
        this.items = items

        // Set Paging
        Object.assign(this.paging, { page, total })
      } catch (_) {
        // Reset Items
        this.items = []

        // Reset Paging
        Object.assign(this.paging, { page: 1, total: 0 })
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
    select(input) {
      // Validate Input
      if (!input) return

      // Select Event
      this.$emit("select", input)

      // Set Input
      this.setInput(input)

      // Close Modal
      this.modal.open = false
    },
  },
}
</script>

<style lang="css" scoped>
.item {
  display: flex;
  padding: var(--size-sm);
  align-items: center;
  height: 100%;
}

.item .item-detail {
  flex: 1;
}
.item .user-detail {
  flex: 1;
}

.user-detail b {
  color: black;
  font-size: 1rem;
}

.detail-name,
.detail-email {
  flex: 1;
}

.item-action .el-button {
  min-width: 5rem;
}

.page-content {
  gap: var(--size-md);
  padding: var(--size-lg);
}

section {
  gap: var(--size-md);
  flex-direction: column;
}
section.content {
  overflow: auto;
}
section.content {
  display: grid;
  gap: var(--size-sm);
  grid-template-columns: repeat(2, 1fr);
  overflow: auto;
}
section.footer {
  gap: var(--size-xs);
  align-items: center;
}

.action-panel {
  width: 100%;
}

.user-dialog >>> .el-dialog {
  max-width: 768px;
}

@media screen and (max-width: 768px) {
  .item {
    gap: var(--size-sm);
  }

  .item,
  .item .item-detail {
    align-items: flex-start;
    flex-direction: column;
  }

  .item .item-detail,
  .item .item-action {
    width: 100%;
  }

  .item .item-action {
    display: grid;
    justify-content: end;
  }
}
</style>
